// extracted by mini-css-extract-plugin
export var fixedType = "Grid-module--fixed--type--ea81b";
export var grid = "Grid-module--grid--2da6a";
export var lgGap = "Grid-module--lg--gap--6e5ed";
export var mdGap = "Grid-module--md--gap--09dd9";
export var smGap = "Grid-module--sm--gap--bc09b";
export var spacing = "Grid-module--spacing--63b10";
export var twoColumnType = "Grid-module--two-column--type--1a623";